import { TableCell, TableRow } from "@mui/material";
import dayjs from "dayjs";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import {
  IApprovalBookingConflict,
  IIneligibleAdditional,
  isValidDateTime,
  MAIN_DATE_FORMAT,
  NO_VALUE_DISPLAY,
} from "@ryde/shared";
import { blueMui } from "@ryde/theme";

import { BulkPreviewStepConflictsContext } from "../bulk-preview-step-conflicts.context";
import { RejectedBookingApprovalButtonTableCell } from "./rejected-booking-approval-button-table-cell";
import { RejectedBookingPassengerTableCell } from "./rejected-booking-passenger-table-cell";

interface IRejectedBookingsPassengerIneligibleRowProps {
  conflictRow: IApprovalBookingConflict;
}

export const RejectedBookingsPassengerIneligibleRow: FC<
  IRejectedBookingsPassengerIneligibleRowProps
> = ({ conflictRow }) => {
  const { t } = useTranslation();
  const { isPreview } = useContext(BulkPreviewStepConflictsContext);
  const {
    errorAdditional,
    date,
    displayDirection,
    passengerFullName,
    passengerId,
    approvalReason,
    errorType,
    id,
  } = conflictRow ?? {};

  const { ineligibleErrorType } =
    (errorAdditional as IIneligibleAdditional) ?? {};

  const ineligibleErrorTypeTranslation = ineligibleErrorType
    ? t(`booking.bulk.ineligibleErrorTypes.${ineligibleErrorType}`)
    : "";

  const formattedDate = isValidDateTime(date)
    ? dayjs(date).format(MAIN_DATE_FORMAT)
    : NO_VALUE_DISPLAY;
  const dateAndDirection = displayDirection
    ? `${formattedDate} (${displayDirection})`
    : formattedDate;

  return (
    <TableRow data-e2e="rejected-bookings-passenger-ineligible-row">
      <RejectedBookingPassengerTableCell passengerId={passengerId}>
        {passengerFullName}
      </RejectedBookingPassengerTableCell>
      <TableCell>
        <div className="cell_simple" color={blueMui.A400}>
          {ineligibleErrorTypeTranslation}
        </div>
      </TableCell>
      <TableCell>
        <div className="cell_simple" color={blueMui.A400}>
          {approvalReason?.name}
        </div>
      </TableCell>
      <TableCell>{dateAndDirection}</TableCell>

      {isPreview && (
        <RejectedBookingApprovalButtonTableCell
          id={id}
          passengerId={passengerId}
          passengerFullName={passengerFullName}
          date={date}
          direction={displayDirection}
          errorType={errorType}
        />
      )}
    </TableRow>
  );
};
